<template>
    <div>
        <DownloadDialog
            v-if="online"
            :selected-tickets="getTicketDetails"
        />
        <SendTicketDialog
            v-if="online"
            :selected-tickets="getTicketResponse"
        />
        <PrintTicketsDialog
            :selected-tickets="getTicketResponse"
        />
        <v-icon
            class="material-icons-outlined mr-7" 
            :disabled="!isClosed"                   
            @click="reopen"
        >
            lock_open
        </v-icon>
    </div>
</template>

<script>
import DownloadDialog from '../TicketsDownload.vue';
import SendTicketDialog from '../TicketsSend.vue';
import PrintTicketsDialog from '../PrintTickets';

export default {
    name: 'ControlIcons',
    components: {
        DownloadDialog,
        SendTicketDialog,
        PrintTicketsDialog,
        
    },
    computed: {
        getTicketDetails() {
            return [this.$store?.getters?.ticketDetails?.Ticket_Status];
        },
        getTicketResponse() {
            if(this.$store?.getters?.ticketDetails?.Ticket_Responses) {
                let ticketResponses = this.$store?.getters?.ticketDetails?.Ticket_Responses.map(item => {
                    return {
                        TR_member_code: item.member_code,
                        TR_rowid: item.rowid,
                        ...item
                    };
                });
                return ticketResponses;
            } else {
                return [];
            }
        },
        online() {
            return !this.$store.getters.forceOffline;
        },
        isClosed() {
            return this.$store.getters.ticketDetails.Ticket_Status.stage === 'CT'? true : false;
        },
    },
    methods: {
        reopen() {
            this.$emit('open-reopen-dialog');           
        },
    }    
};
</script>